import React from 'react';
import { useLoading } from "../../../../../../hooks/LoadingHook";
import pagarme from 'pagarme';
import { useModal } from "../../../../../../hooks/Modal";
import { useLanguage } from "../../../../../../hooks/Language";
import { gateKey } from '../../../../../../config';
import { useToast } from '../../../../../../hooks/Toast';
import { useParams } from 'react-router-dom';
import usePaymentRequest from './paymentRequest';
import { createCardToken } from '../createCardToken';

interface ICardProps {
  id?: string;
  card_holder_name: string;
  card_expiration_date: string;
  card_number: string;
  card_cvv: string;
  installments?: number;
  document_type: string;
}


export default function usePaymentWithCreditCard() {

  const { paymentRequest } = usePaymentRequest()
  const { projectHash, eventHash } = useParams<Record<string, any>>()
  const { translate, language } = useLanguage();
  const { addLoading, removeLoading } = useLoading();
  const { addModal } = useModal();
  const { addToast } = useToast();

  const payWithCreditCard = async ({ paymentContext, moveToCart }) => {




    const expiration = paymentContext?.card?.card_expiration_date?.split('/')

    const creditCardInfo = {
      number: paymentContext?.card?.card_number,
      holder_name: paymentContext?.card?.card_holder_name,
      exp_month: expiration?.[0],
      exp_year: expiration?.[1],
      cvv: paymentContext?.card?.card_cvv,


    }

    const cardItem = await createCardToken(creditCardInfo);

    if (cardItem?.status === 'error') {
      addModal({ theme: 'whiteModalMini', title: '', content: <> <p style={{ color: '#333', padding: '10px', fontSize: '14px', textAlign: 'center', width: '100%' }}>{'Erro ao validar seu cartão de crédito, verifique seus dados.'} </p></> })
      removeLoading('loading')
      return false;
    }
    const card_hash = cardItem?.response;

    paymentContext.billing = {
      paymentMethod: 'credit_card',
      credit_card_hash: card_hash,
      installments: paymentContext?.billing?.installments,
      document_type: paymentContext?.billing?.document_type,
    };

    paymentContext.card = {};


    await paymentRequest({ paymentContext, moveToCart });

    return false;


  }

  return { payWithCreditCard };

}